import { RouteRecordRaw } from "vue-router";
import App from '../../App.vue';

export const AcceptorRoutes: RouteRecordRaw = {
    path: '/acceptor',
    redirect: "/acceptor/manage-contracts",
    component: App,
    meta: {
        title: "Creative Contract Acceptor Portal",
        metaTags: [
            {
                name: "description",
                content: "Acceptor Portal",
            },
        ],
    },
    children: [
        {
            path: "manage-contracts",
            name: "manage-contracts",
            component: () => import("../../modules/acceptor/pages/ManageContracts.vue"),
        },
        {
            path: "read-contract",
            name: "read-contract",
            component: () => import("../../modules/acceptor/pages/acceptor-read-contract.vue"),
        },
    ],
};
